/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceMetricHierarchyRequest {
    getFixupPrototypeFunction() { return ResourceMetricHierarchyRequest.fixupPrototype; }

    static newInstance(model: Partial<ResourceMetricHierarchyRequest>): ResourceMetricHierarchyRequest {
        let obj = Object.assign(new ResourceMetricHierarchyRequest(), model);
        ResourceMetricHierarchyRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceMetricHierarchyRequest>): ResourceMetricHierarchyRequest {
        if (!model) return null;
        return ResourceMetricHierarchyRequest.newInstance(<ResourceMetricHierarchyRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceMetricHierarchyRequest) {
        if (!obj) return;

        models.ResourceMetricHierarchyRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceMetricHierarchyRequest): boolean {
        Object.setPrototypeOf(obj, ResourceMetricHierarchyRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Template URI
     */
    template_uri: string;

    /**
     * Cloud Service Name
     */
    service: models.CloudServiceName;

}
